/**
 * The band under every authenticated page.
 *
 * Not to be confused with `Footer`, which is the public marketing one on the
 * twelve pillar and resource pages. They were the same component and should
 * not be: a marketing footer's job is to give a stranger somewhere else to go,
 * and this one's job is the opposite. Everything a signed-in person navigates
 * with is already in the rail and the header, so what belongs here is only
 * what belongs nowhere else.
 *
 * By that rule it lost one link and gained two.
 *
 * "Resources" pointed at /aeo, which is one entry in the header's own
 * Resources menu and in the drawer's Reading group. A third route to a subset
 * of the same list is not a shortcut.
 *
 * "Help" pointed at /docs while the header's Help button opened the support
 * dialog, and the footer's "Support" opened that same dialog. So the app had
 * two different things called Help and two names for one dialog. The dialog is
 * reachable as "Help" from the header on a wide screen and from the drawer on
 * a phone, so it does not need a third door under a second name. The docs keep
 * their link and are called Docs.
 *
 * Privacy and Terms are new here, and they are the reason this is worth doing:
 * they are linked from eighteen public pages and from nowhere at all inside
 * the product. Somebody paying for this could not reach the terms they agreed
 * to without signing out.
 */
import { Link } from 'react-router-dom'
import { DsIsland } from '@/design-system/island'
import '@/design-system/app.css'

export default function AppFooter() {
  return (
    <DsIsland panel={false} ground={false} className="ds-appfoot">
      {/* "All rights reserved." is not doing anything. The notice is the © and
          the name; the phrase has been decorative for a quarter of a century. */}
      <p className="ds-appfoot__who">
        © {new Date().getFullYear()} Lightbulb Moment Labs
      </p>
      <nav className="ds-appfoot__links" aria-label="Legal and documentation">
        <Link to="/docs">Docs</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
      </nav>
    </DsIsland>
  )
}
